import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Select from "@material-ui/core/Select"
import { MenuItem } from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import StoreList from "./StoreList"
import { RichDescription, RichTitle } from ".."

import { FormattedMessage } from "react-intl"

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
  },
  banner: {
    height: "300px",
    width: "100vw",
    backgroundColor: props =>
      props.styling.heroBannerColor
        ? props.styling.heroBannerColor
        : theme.palette.invertedGreen.support,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage:
      "url('../../puraearth/src/images/pura earth symbol background.svg')",
  },
  bannerText: {
    color: theme.palette.green.main,
    textAlign: "center",
  },
  subContainer: {
    width: "80%",
    textAlign: "left",
    maxWidth: theme.spacing(78),
  },
  locations: {
    marginBottom: "16px",
    marginTop: theme.spacing(10),
  },
  select: {
    width: "100%",
    border: "1px solid",
    borderColor: theme.palette.black.supportLight,
    padding: theme.spacing(2, 2, 2.5, 2.5),
    "&:focus": {
      backgroundColor: "white",
    },
  },
  formControl: {
    width: "100%",
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  province: props => ({
    color: theme.palette.green.main,
    marginTop: theme.spacing(10),
    fontSize:
      props.styling.cityStyling && props.styling.cityStyling.fontSize
        ? parseInt(props.styling.cityStyling.fontSize)
        : 20,
    fontFamily:
      props.styling.cityStyling && props.styling.cityStyling.fontFamily
        ? props.styling.cityStyling.fontFamily
        : ["Proxima Nova", "Roboto", "Helvetica", "Arial", "sans-serif"].join(
            ","
          ),
    fontWeight:
      props.styling.cityStyling && props.styling.cityStyling.fontWeight
        ? parseInt(props.styling.cityStyling.fontWeight)
        : 400,
    letterSpacing:
      props.styling.cityStyling && props.styling.cityStyling.letterSpacing
        ? props.styling.cityStyling.letterSpacing
        : "0px",
    lineHeight:
      props.styling.cityStyling && props.styling.cityStyling.lineHeight
        ? props.styling.cityStyling.lineHeight
        : "32px",
    textTransform:
      props.styling.cityStyling && props.styling.cityStyling.textTransform,
    color:
      props.styling.cityStyling && props.styling.cityStyling.fontColor
        ? props.styling.cityStyling.fontColor
        : "#212221",
  }),
  divLine: {
    height: "1px",
    maxWidth: "1296px",
    marginRight: "auto",
    marginBottom: "32px",
    marginLeft: "auto",
    marginTop: theme.spacing(11),
    backgroundColor: theme.palette.black.supportLight,
    width: "90%",
  },
}))

// const groupBy = key => array =>
//   array.reduce((objectsByKeyValue, obj) => {
//     const value = obj[key]
//     objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
//     return objectsByKeyValue
//   }, {})

export default props => {
  const classes = useStyles(props)
  const [selectedProvince, setProvince] = useState("")
  const [selectedStores, setStores] = useState([])

  const storesByProvince = props.stores.reduce((groupedStores, item) => {
    const value = item.next.storeLocation.province
    groupedStores[value] = (groupedStores[value] || []).concat(item)
    return groupedStores
  }, {})

  const provinces = Object.keys(storesByProvince)

  const handleSelectChange = event => {
    const province = event.target.value
    setProvince(province)
    setStores(storesByProvince[province])
  }

  return (
    <div className={classes.container}>
      <div className={classes.banner}>
        <Typography variant={"h1"} classes={{ root: classes.bannerText }}>
          {props.styling.pageTitle && (
            <RichTitle titleText={props.styling.pageTitle} />
          )}
        </Typography>
      </div>
      <div className={classes.subContainer}>
        <Typography variant={"body1"} classes={{ root: classes.locations }}>
          <FormattedMessage id="selectCityStore" />
        </Typography>
        <FormControl className={classes.formControl}>
          <Select
            classes={{ root: classes.select, icon: classes.icon }}
            onChange={handleSelectChange}
            value={selectedProvince}
            IconComponent={ExpandMoreIcon}
            displayEmpty
          >
            <MenuItem value="" disabled>
              <FormattedMessage id="selectACity" />
            </MenuItem>
            {provinces.sort().map((item, index) => (
              <MenuItem value={item} key={index}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {selectedProvince && (
          <div className={classes.province}>{selectedProvince}</div>
        )}
        <StoreList
          styling={props.styling}
          province={selectedProvince}
          stores={selectedStores}
        />
      </div>
      <div className={classes.divLine} />
    </div>
  )
}
